import * as Turbo from '@hotwired/turbo';

// Turbo.start();

import * as ActiveStorage from '@rails/activestorage';

ActiveStorage.start();

import '@hotwired/turbo-rails';

import './application.scss';
